import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AccountCreationDialogueHandler } from '../types';
import AccountCreationDialogueContext from './AccountCreationContext';

const { ConfirmationDialogue } = vp;

type AccountCreationDialogueProps = {
  handleDialogue: DialogueHandler<AccountCreationDialogueHandler>;
};

type FC = FunctionComponent<AccountCreationDialogueProps>;

const AccountCreationDialogue: FC = ({ handleDialogue }: AccountCreationDialogueProps) => {
  const { showAccountCreationSuccessAlert, showAccountCreationErrorAlert, accountCreationError } =
    useContext(AccountCreationDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Account Creation Error */}
        <ConfirmationDialogue
          isVisible={showAccountCreationErrorAlert}
          title="Error! The contact was not created."
          status="error"
          subTitle={`${accountCreationError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
        {/* Account Creation Success */}
        <ConfirmationDialogue
          isVisible={showAccountCreationSuccessAlert}
          title="The contact was successfully created."
          status="success"
          subTitle=""
          confirm={{
            label: 'Back to Contacts',
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showAccountCreationSuccessAlert, showAccountCreationErrorAlert, accountCreationError],
  );
};

export default AccountCreationDialogue;
